export const STATUS_REQUEST: {[key:string] : string } = {
    PENDING: 'PENDING',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED:'COMPLETED',
    CANCELED: 'CANCELED',
}